/* eslint-disable max-len */
import React from 'react';
import {IconProps} from './types';

export const CocktailIconSVG: React.FC<IconProps> = ({ isWithBorder }) => {
  return (
    <svg width="42" height="42">
      <g fill="none" fillRule="evenodd">
        {isWithBorder && (
          <path
            d="M37.246 0c0 2.89 1.756 4.023 3.134 4.468l.261.077.126.033.241.055.114.023.212.036.274.036.309.024.083.002v32.492c-2.89 0-4.023 1.756-4.468 3.134l-.077.261a6.125 6.125 0 0 0-.033.126l-.055.241a6.301 6.301 0 0 0-.023.114l-.036.212-.036.274-.024.309-.002.083H4.754c0-2.89-1.756-4.023-3.134-4.468l-.261-.077a6.125 6.125 0 0 0-.126-.033l-.241-.055a6.3 6.3 0 0 0-.114-.023l-.212-.036-.274-.036-.309-.024L0 37.246V4.754c2.89 0 4.023-1.756 4.468-3.134l.077-.261.033-.126.055-.241a6.3 6.3 0 0 0 .023-.114l.036-.212.036-.274.024-.309L4.754 0h32.492Zm-.782.827H5.503l-.04.237a6.454 6.454 0 0 1-.648 1.846c-.756 1.398-2 2.332-3.756 2.595l-.232.03v30.961l.237.041a6.454 6.454 0 0 1 1.846.648c1.398.756 2.332 2 2.595 3.756l.03.232h30.96l.042-.237a6.454 6.454 0 0 1 .648-1.846c.756-1.398 2-2.332 3.756-2.595l.232-.031V5.504l-.237-.041a6.454 6.454 0 0 1-1.846-.648c-1.398-.756-2.332-2-2.595-3.756l-.031-.232Z"
            fill="#CCCBCB"
            fillRule="nonzero"
          />
        )}
        <path d="M6 6h30v30H6z" />
        <path
          d="M33 11.853C33 10.83 32.17 10 31.147 10H11.853C10.83 10 10 10.83 10 11.853c0 .447.166.894.473 1.226l9.75 10.977v6.388H15.11c-.703 0-1.278.575-1.278 1.278 0 .703.575 1.278 1.278 1.278H27.89c.703 0 1.278-.575 1.278-1.278 0-.703-.575-1.278-1.278-1.278h-5.111v-6.388l9.75-10.977A1.82 1.82 0 0 0 33 11.853ZM15.66 15.11 13.4 12.556h16.215l-2.275 2.555H15.661Z"
          fill="#433770"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};
